import 'src/assets/css/alerts.css';
import alert from 'sweetalert2';
import i18n from '../i18n';

class SweetAlert {
  static download(message, sAlert) {
    let timerInterval;
    sAlert.fire({
      title: i18n.t('cla.alerts.text1'),
      allowOutsideClick: false,
      html: '<br>' + message,
      onBeforeOpen: () => {
        alert.showLoading();
      },
      onClose: () => {
        clearInterval(timerInterval);
      },
    });
    return;
  }

  static prueba(message) {
    return alert({
      title: i18n.t('common_words.temporal2'),
      type: 'success',
      html: message,
      confirmButtonClass: 'btn btn-success btn-fill',
      buttonsStyling: false,
      showConfirmButton: true,
      allowOutsideClick: false,
    });
  }

  static success(message) {
    return alert({
      type: 'success',
      html: message,
      confirmButtonClass: 'btn btn-success btn-fill',
      buttonsStyling: false,
    });
  }

  static warning(message) {
    return alert({
      type: 'warning',
      html: message,
      confirmButtonClass: 'btn btn-warning btn-fill',
      buttonsStyling: false,
    });
  }

  static danger(message) {
    return alert({
      type: 'error',
      html: message,
      confirmButtonClass: 'btn btn-danger btn-fill',
      buttonsStyling: false,
    });
  }

  static input(message, html = null, btnText = null, input = null) {
    return alert({
      title: message,
      html: html,
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonText: i18n.t('common_words.cancel'),
      confirmButtonText: btnText,
      confirmButtonClass: 'btn btn-success btn-fill',
      cancelButtonClass: 'btn btn-danger btn-fill',
      input: input.type,
      inputPlaceholder: input.placeholder,
      buttonsStyling: false,
    });
  }

  static next(message, html = null, btnText = null) {
    return alert({
      title: message,
      html: html,
      confirmButtonText: btnText,
      confirmButtonClass: 'btn btn-success btn-fill',
      cancelButtonClass: 'btn btn-danger btn-fill',
      buttonsStyling: false,
    });
  }

  static delete(message, html = i18n.t('common_words.this_record')) {
    return alert({
      title: i18n.t('common_words.delete') + ' ' + message,
      text: i18n.t('cla.alerts.text2') + ' ' + html + '?',
      type: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: i18n.t('common_words.delete'),
      cancelButtonText: i18n.t('common_words.no'),
      confirmButtonClass: 'btn btn-success btn-fill',
      cancelButtonClass: 'btn btn-danger btn-fill',
      buttonsStyling: false,
    });
  }

  static disable(message, html = i18n.t('common_words.this_record')) {
    return alert({
      title: message,
      text: i18n.t('cla.alerts.text3') + ' ' + html + '?',
      type: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: i18n.t('common_words.yes_disable'),
      cancelButtonText: i18n.t('common_words.cancel'),
      confirmButtonClass: 'btn btn-success btn-fill',
      cancelButtonClass: 'btn btn-danger btn-fill',
      buttonsStyling: false,
    });
  }

  static confirm(message, html) {
    return alert({
      title: message,
      text: html,
      type: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: i18n.t('common_words.confirm'),
      cancelButtonText: i18n.t('common_words.cancel'),
      confirmButtonClass: 'btn btn-success btn-fill',
      cancelButtonClass: 'btn btn-danger btn-fill',
      buttonsStyling: false,
    });
  }

  static temporary(
    message,
    html,
    button_text = i18n.t('common_words.activate')
  ) {
    return alert({
      title: message,
      text: html,
      type: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: button_text,
      cancelButtonText: i18n.t('common_words.cancel'),
      confirmButtonClass: 'btn btn-success btn-fill',
      cancelButtonClass: 'btn btn-danger btn-fill',
      buttonsStyling: false,
    });
  }

  static continue(message) {
    return alert({
      type: 'success',
      html: message + ' ' + i18n.t('cla.alerts.text4'),
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: i18n.t('common_words.continue'),
      cancelButtonText: i18n.t('common_words.exit'),
      confirmButtonClass: 'btn btn-success btn-fill',
      cancelButtonClass: 'btn btn-danger btn-fill',
      buttonsStyling: false,
    });
  }

  static default(message, html = null, btnText = null, type = null) {
    return alert({
      title: message,
      html: html,
      type: type == 0 ? 'warning' : 'success',
      showCancelButton: true,
      cancelButtonText: i18n.t('common_words.cancel'),
      allowOutsideClick: false,
      confirmButtonText: btnText,
      confirmButtonClass: 'btn btn-success btn-fill',
      cancelButtonClass: 'btn btn-danger btn-fill',
      buttonsStyling: false,
    });
  }

  static select(
    title,
    message,
    btnText,
    inputOptions,
    inputPlaceholder = i18n.t('common_words.select') + ' ...'
  ) {
    let options = {};
    inputOptions.map((item) => {
      options[item.id] = item.name;
    });

    return alert({
      title: title,
      html: message,
      input: 'select',
      confirmButtonText: btnText,
      inputOptions: options,
      inputPlaceholder: inputPlaceholder,
      confirmButtonClass: 'btn btn-success btn-fill',
      cancelButtonClass: 'btn btn-danger btn-fill',
      allowOutsideClick: false,
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value.length <= 0) {
            resolve(i18n.t('cla.alerts.text5') + '...');
          } else {
            resolve();
          }
        });
      },
    });
  }
}

export default SweetAlert;
